// extracted by mini-css-extract-plugin
module.exports = {"splitter":"splitter___1Peoq"};